import {
  Box,
  Card as MuiCard,
  CardContent,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  Button,
  MenuItem,
  Select,
  Slide,
  TextField as MuiTextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import SearchIcon from "@mui/icons-material/Search";
import { spacing } from "@mui/system";
// Redux Components
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { EditableTable } from "../../../components/EditableTable";
import { get as getaging } from "../api/actions";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../snackbar/api/snackbar";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const Card = styled(MuiCard)(spacing);
const TextField = styled(MuiTextField)(spacing);
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Table(props) {
  const [yearsBack, setYearsBack] = React.useState(
    props.accounting.data.searchQuery.yearsBack || 1
  );
  // Reports can only be emailed to you or another active staff member, so start with your own address.
  // A typed address stays with this tab (not the shared redux state), so the next person to sign in gets their own.
  const userEmail = props.user?.details?.email || "";
  const typedEmail = React.useRef(null);

  const handleSearchTargetChangeDate = (event) => {
    props.accounting.data.searchQuery.date = event.target.value;
    let params = [
      props.accounting.data.searchQuery.date,
      yearsBack,
    ];
  };

  const dispatch = useDispatch();


  const handleSearchTargetChangeEmail = (event) => {
    typedEmail.current = event.target.value;
  };

  const sendRequest = () => {
    const email = (typedEmail.current ?? userEmail).trim();
    if (!props.accounting.data.searchQuery.date || yearsBack == null || !email) {
      dispatch(setSnackbar(true, "error", "Must fill out all fields."))
      return;
    }


    let params = [
      props.accounting.data.searchQuery.date,
      yearsBack,
    ];

    props.getaging(
      { ...props.accounting.data.searchQuery, yearsBack },
      true,
      "",
      "CalculateAging",
      params,
      "agingList",
      email
    );
  }

  const handleSearchTargetChangeYearsBack = (event) => {
    setYearsBack(Number(event.target.value));
    let params = [
      props.accounting.data.searchQuery.date,
      Number(event.target.value),
    ];

  };

  const CurrentLookupTypeButton = () => {
    return (
      <IconButton>
        <SearchIcon mr={2} />
      </IconButton>
    );
  };

  const SearchBar = () => {
    return (
      <Box sx={{ 
        maxWidth: 600, 
        mx: 'auto',
        p: 3,
        backgroundColor: 'background.paper',
        borderRadius: 1,
        boxShadow: 1
      }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              Request Aging Report
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              id={"dateText"}
              defaultValue={props.accounting.data.searchQuery.date ?? ""}
              label="As of Date"
              type={"date"}
              onChange={handleSearchTargetChangeDate}
              name={"date"}
              fullWidth
              size={"medium"}
              variant={"outlined"}
              InputLabelProps={{
                shrink: true,
              }}
              helperText="Aging report as of date"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel id="age-select-label">Age</InputLabel>
              <Select
                labelId="age-select-label"
                value={yearsBack}
                onChange={handleSearchTargetChangeYearsBack}
                label="Age"
              >
                <MenuItem value={1}>1 Year</MenuItem>
                <MenuItem value={2}>2 Years</MenuItem>
                <MenuItem value={3}>3 Years</MenuItem>
                <MenuItem value={4}>4 Years</MenuItem>
                <MenuItem value={5}>5 Years</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField
              id={"emailText"}
              defaultValue={typedEmail.current ?? userEmail}
              label="Email"
              type={"text"}
              onChange={handleSearchTargetChangeEmail}
              name={"email"}
              fullWidth
              size={"medium"}
              variant={"outlined"}
              InputLabelProps={{
                shrink: true,
              }}
              helperText="Your address or another active staff member's. The report is emailed there."
            />
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={sendRequest}
                size="large"
              >
                Request Report
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    );
  };

  // Table Stuff:
  const fieldTitles = ["Account", "0-30", "31-60", "61-90", ">90"];
  const fieldTypes = ["label", "label", "label", "label", "label"];
  const fieldNames = [
    "AccountNum",
    "Aging_0_30",
    "Aging_31_60",
    "Aging_61_90",
    "Aging_Over_91",
  ];

  const onSelected = (item) => { };

  const onUpdate = () => {
    hide();
  };

  const [display, setDisplay] = React.useState(false);

  const show = () => {
    props.accounting.data.agingList = {}; // TODO: clear property on popup show
    setDisplay(true);
  };

  const hide = () => {
    setDisplay(false);
  };

  const NewDialog = () => {
    return (
      <Dialog
        open={display}
        TransitionComponent={Transition}
        fullWidth={"lg"}
        maxWidth={"lg"}
        keepMounted
        onClose={hide}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">New Aging</DialogTitle>
        <DialogContent></DialogContent>
      </Dialog>
    );
  };

  return (
    <Card mb={6} elevation={3}>
      <CardContent>
        <NewDialog />
        <SearchBar />
        {/* <EditableTable
          readOnly={false}
          isLoading={props.accounting.isLoading}
          handleRowClickParentMethod={onSelected}
          tableTitle={"Aging"}
          canAddItems={false}
          canSave={false}
          canExport={true}
          objectArray={props.accounting.data.agingList}
          fieldTitles={fieldTitles}
          fieldTypes={fieldTypes}
          fieldNames={fieldNames}
        /> */}
      </CardContent>
    </Card>
  );
}

Table.propTypes = {
  user: PropTypes.object.isRequired,
  apl: PropTypes.object.isRequired,
  accounting: PropTypes.object.isRequired,
  getaging: PropTypes.func.isRequired,
};

function State(state) {
  return {
    user: state.user,
    apl: state.apl,
    accounting: state.accounting,
    search: state.search,
  };
}

export default connect(State, { getaging })(Table);
